import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import { currencies } from 'dibs-currency-helpers';
import { createFragmentContainer, graphql } from 'react-relay';
import get from 'lodash.get';
import { addAndApplyFilter } from '../../../actions/filterActions';

import { hasPriceFilterApplied } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuInputRange } from './SbSharedRefineMenuInputRange';

const { labelTo, labelFrom } = defineMessages({
    labelTo: {
        id: 'sb.SbSharedRefineMenuFilterPrice.maximum',
        defaultMessage: '{currency} max',
    },
    labelFrom: {
        id: 'sb.SbSharedRefineMenuFilterPrice.minimum',
        defaultMessage: '{currency} min',
    },
});

export const SbSharedRefineMenuInputRangeCurrencyComponent = props => {
    const {
        size,
        currency,
        onApplyCallback,
        applyOnBlur,
        searchBrowse,
        showInvalidRangeErrorMessage,
        intl,
    } = props;
    // The price values should be prefilled if they are
    // coming from appliedFilters
    const appliedFilters = get(searchBrowse, 'appliedFilters');
    const showAnimatedPlaceholder = !hasPriceFilterApplied(appliedFilters);

    return (
        <SbSharedRefineMenuInputRange
            {...props}
            size={size}
            labelTo={intl.formatMessage(labelTo, { currency })}
            statKey={currency}
            labelFrom={intl.formatMessage(labelFrom, { currency })}
            applyOnBlur={applyOnBlur}
            onApplyCallback={onApplyCallback}
            showInvalidRangeErrorMessage={showInvalidRangeErrorMessage}
            showAnimatedPlaceholder={showAnimatedPlaceholder}
        />
    );
};

SbSharedRefineMenuInputRangeCurrencyComponent.defaultProps = {
    onApplyCallback: () => {},
};

SbSharedRefineMenuInputRangeCurrencyComponent.propTypes = {
    intl: intlShape.isRequired,
    applyOnBlur: PropTypes.bool,
    onApplyCallback: PropTypes.func,
    currency: PropTypes.string.isRequired,
    searchBrowse: PropTypes.object.isRequired,
    showInvalidRangeErrorMessage: PropTypes.bool,
    size: PropTypes.oneOf(['small', 'medium', 'large']),
};

function mapDispatchToProps(dispatch, props) {
    const { currency } = props;
    return {
        onApplyCallback() {
            if (currencies.includes(currency)) {
                dispatch(
                    addAndApplyFilter('currency', {
                        urlLabel: currency.toLowerCase(),
                    })
                );
            }
        },
    };
}

export const SbSharedRefineMenuInputRangeCurrency = createFragmentContainer(
    injectIntl(
        connect(
            null,
            mapDispatchToProps
        )(SbSharedRefineMenuInputRangeCurrencyComponent)
    ),
    {
        searchBrowse: graphql`
            fragment SbSharedRefineMenuInputRangeCurrency_searchBrowse on SearchBrowseQueryConnection {
                ...SbSharedRefineMenuInputRange_searchBrowse
                appliedFilters {
                    name
                }
            }
        `,
    }
);
